<template>
	<div class="check-bottom">
		<div class="check-content">
			<div class="title">
				<div class="text">{{ caseText }}</div>
				<img class="arrow_btm" :src="require('../../../../assets/appraise/arrowbtm.png')" @click="close" />
			</div>
			<div class="link-text">
                <textarea v-model="value" placeholder="请将案件链接复制粘贴到此处"></textarea>
            </div>
			<div class="btm_btn">
				<cusBtn2 value="确定" @click="confirm"></cusBtn2>
			</div>
		</div>
	</div>
</template>
<script>
import { CheckboxGroup, Checkbox, } from "vant";
import cusBtn2 from "./cusBtn2";
export default {
    name: "bottomCheckbox",
    comments: {
        CheckboxGroup,
        Checkbox,
    },
	props: {
		caseData: {
			type: Array,
			default: () => {
				return [
					{ id: "traffic", text: "交通" },
					{ id: "police", text: "公安" },
					{ id: "tax", text: "税务" },
					{ id: "cult_tour", text: "文化和旅游" },
					{ id: "market_monitor", text: "市场监管" },
				];
			},
		},
		caseText: {
			type: String,
			default: () => {
				return "新增链接";
			},
		},
	},
	components: {
		cusBtn2,
	},
	data() {
		return {
			value: '',
		};
	},
	methods: {
        /** 确认 **/
        confirm() {
            this.$emit('onConfirm', this.value);
            this.close();
        },
        /** 关闭 **/
        close() {
            this.$emit('onClose');
        }
	},
};
</script>
<style lang="less" scoped>
.check-bottom {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
	position: fixed;
	top: 0;
	left: 0;
	.check-content {
		width: 100%;
		height: 230px;
		background: rgba(255, 255, 255, 1);
		position: absolute;
		bottom: 0;
        .link-text {
            width: 100%;
            height: 120px;
            padding: 16px 12px;
            background: rgba(245, 245, 245, 1);
            border-radius: 3px;
            textarea {
                outline: none;
                border: none;
                resize: none;
                width: 100%;
                height: 100%;
                line-height: 24px;
                background: rgba(245, 245, 245, 1);
            }
            textarea::-webkit-input-placeholder {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(204, 204, 204, 1);
            }
            textarea:-moz-placeholder {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(204, 204, 204, 1);
            }
            textarea:-ms-input-placeholder {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(204, 204, 204, 1);
            }
        }
		.title {
			display: flex;
			justify-content: space-between;
			padding: 16px 18px 16px 15px;
			.text {
				min-width: 100px;
				font-size: 16px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 900;
				color: rgba(51, 51, 51, 1);
			}
			.arrow_btm {
				width: 14px;
				height: 14px;
			}
		}
		.btm_btn {
			height: 61px;
			width: 100%;
			display: flex;
			align-items: center;
			padding: 0 12px;
			position: absolute;
			bottom: 0;
		}
	}
}
</style>
